import React from "react";
import LoadingComponent from "commons/loading/Loading.component";
import { getImageUrl } from "helpers/Image.helper";

const KoachHomeComponent = (props: any) => {
    const {
        isLoading,
        followerList,
        followerListLoading,
        handleShowStudentInfoPopup
    } = props;

    if (isLoading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <main className="bg-gray-50 min-h-screen pt-20 pb-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    {/* 팔로워 목록 (지망생 목록) */}
                    <div className="mb-8">
                        {followerListLoading ? (
                            <div className="overflow-x-auto scrollbar-hide">
                                <div className="flex gap-0.5">
                                    {/* 지망생 목록 스켈레톤 */}
                                    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                                        <div key={i} className="w-[80px] sm:w-[90px] lg:w-[100px] flex-shrink-0">
                                            <div className="flex flex-col items-center">
                                                <div className="rounded-full w-14 h-14 sm:w-16 sm:h-16 bg-gray-200 animate-pulse aspect-square"></div>
                                                <div className="mt-2 w-full">
                                                    <div className="h-3 bg-gray-200 rounded animate-pulse mx-auto w-3/4"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : followerList.length > 0 ? (
                            <div className="overflow-x-auto scrollbar-hide">
                                <div className="flex gap-0.5">
                                    {followerList.map((student: any) => {
                                        // 프로필 이미지 URL 생성 (리사이즈 쿼리스트링 추가)
                                        const getProfileImageUrl = () => {
                                            if (student.profileImageUrl) {
                                                // URL에 이미 쿼리스트링이 있는지 확인
                                                const separator = student.profileImageUrl.includes('?') ? '&' : '?';
                                                return `${student.profileImageUrl}${separator}w=100`;
                                            }
                                            if (student.profileImage) {
                                                return getImageUrl(student.profileImage, 100, 100);
                                            }
                                            return '/imgs/dummy/basic-img.png';
                                        };

                                        return (
                                            <div 
                                                key={student.id} 
                                                className="w-[80px] sm:w-[90px] lg:w-[100px] flex-shrink-0 cursor-pointer"
                                                onClick={() => {
                                                    if (handleShowStudentInfoPopup) {
                                                        // 지망생 정보 팝업 열기 (userStudentId 사용)
                                                        handleShowStudentInfoPopup(student.id);
                                                    }
                                                }}
                                            >
                                                <div className="flex flex-col items-center">
                                                    <div className="relative rounded-full w-14 h-14 sm:w-16 sm:h-16 flex-shrink-0 aspect-square">
                                                        <div className="rounded-full overflow-hidden w-full h-full border border-gray-100 aspect-square">
                                                            <img
                                                                src={getProfileImageUrl()}
                                                                alt={student.nickname || '지망생'}
                                                                className="w-full h-full object-cover"
                                                                onError={(e) => {
                                                                    const target = e.target as HTMLImageElement;
                                                                    target.src = '/imgs/dummy/basic-img.png';
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="mt-2 text-center w-full overflow-hidden">
                                                        <p className="text-gray-900 text-xs truncate px-1">
                                                            {student.nickname || '지망생'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </main>
        </>
    );
};

export default KoachHomeComponent; 